import { X } from 'lucide-react'
import Image from 'next/image'
import { useState } from 'react'
import type { EnumProductType } from '@/types/enum-product-type'
import 'react-phone-input-2/lib/style.css'
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogTitle,
} from '../ui/alert-dialog'
import SignInForm from './sign-in-form'
import SignUpForm from './sign-up-form'
import VerifyUserForm from './verify-user-form'

interface EnrolmentDataType {
  product_id: string
  product_external_id?: number
  workload_value?: number
  workload_id: string
  period_id: string
}

interface SignInModalProps {
  notLoggedIn: boolean
  enrolmentData: EnrolmentDataType | null
  externalIdProduct: string | null
  productType: EnumProductType
  referenceProduct: string
  setNotLoggedIn: (value: boolean) => void
  setShouldShowFormAuth: (value: boolean) => void
}

export default function ModalLayout({
  notLoggedIn,
  enrolmentData,
  setNotLoggedIn,
  externalIdProduct,
  referenceProduct,
  productType,
  setShouldShowFormAuth,
}: SignInModalProps) {
  const [viewForm, setViewForm] = useState<'sign-in' | 'sign-up' | 'verify'>(
    'verify'
  )
  const [email, setEmail] = useState('')

  return (
    <AlertDialog onOpenChange={setNotLoggedIn} open={notLoggedIn}>
      <AlertDialogContent className="grid max-w-md grid-cols-1 gap-0 rounded-lg border-none p-0 md:min-h-140 md:min-w-175 md:grid-cols-2">
        <div className="col-span-1 hidden rounded-l-lg bg-[#5E42F9] md:block">
          <Image
            alt=""
            className="mt-4 w-[20rem] rounded-l-lg"
            height={200}
            src="/img/modal-logout.webp"
            width={200}
          />

          <div className="mt-6">
            <AlertDialogTitle className="text-center font-bold text-2xl text-white">
              Estamos quase lá!
            </AlertDialogTitle>

            <p className="text-center text-sm text-white">
              Você está quase concluindo a sua inscrição.
            </p>
          </div>
        </div>

        <div className="col-span-1 px-2.5 py-4">
          <button
            className="mr-2 ml-auto flex w-max items-center gap-2 rounded-md px-3 py-2 font-medium text-gray-700 text-sm transition-colors hover:bg-gray-100"
            onClick={() => {
              setNotLoggedIn(false)
              setShouldShowFormAuth(false)
            }}
            type="button"
          >
            Fechar
            <X className="size-4" />
          </button>

          <p className="mt-4 text-gray-400 text-sm">
            Preencha os campos abaixos com suas informações para realizar sua
            pré-inscrição:
          </p>

          {viewForm === 'verify' && (
            <VerifyUserForm setEmail={setEmail} setViewForm={setViewForm} />
          )}
          {viewForm === 'sign-in' && (
            <SignInForm
              email={email}
              enrolmentData={enrolmentData}
              externalIdProduct={externalIdProduct}
              productType={productType}
              referenceProduct={referenceProduct}
            />
          )}
          {viewForm === 'sign-up' && (
            <SignUpForm
              email={email}
              enrolmentData={enrolmentData}
              externalIdProduct={externalIdProduct}
              productType={productType}
              referenceProduct={referenceProduct}
            />
          )}
        </div>
      </AlertDialogContent>
    </AlertDialog>
  )
}
